// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"786":"bba9409a","1863":"bba9409a","5879":"bba9409a","7134":"bba9409a","7433":"bba9409a"}[chunkId] + ".chunk.css";
};